import React, { FC } from 'react';
import {
  AppBar as MuiAppBar,
  Avatar,
  Stack,
  Toolbar,
  IconButton as MuiIconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import styled from 'styled-components/macro';
import { Menu as MenuIcon } from '@mui/icons-material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

import { useNavigate } from 'react-router-dom';

import { useAuth } from '../context/auth-context';
import { UserRole } from '../types/user.types';
import OrganizationSwitch from './OrganizationSwitcher';
import MiniLogo from './sidebar/MiniLogo';

const AppBar = styled(MuiAppBar)`
  background-color: #ffffff;
  color: #1e293b;
  border-bottom: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
  cursor: pointer;
`;

interface INavBar {
  onDrawerToggle?: React.MouseEventHandler<HTMLButtonElement>;
}

const NavBar: FC<INavBar> = ({ onDrawerToggle }) => {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();
  const userInitial = (currentUser?.name || currentUser?.email || 'U')
    .charAt(0)
    .toUpperCase();
  const isSuperAdmin = currentUser?.role === UserRole.superAdmin;

  return (
    <AppBar color="inherit" position="sticky" elevation={0}>
      <Toolbar sx={{ minHeight: '64px !important', px: 2 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          sx={{ width: '100%' }}
        >
          <Stack direction="row" alignItems="center" spacing={2} minWidth={0}>
            {onDrawerToggle && (
              <IconButton
                color="inherit"
                aria-label="Toggle navigation"
                onClick={onDrawerToggle}
                size="small"
                sx={{ color: '#64748b' }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <IconButton
              onClick={() => navigate('/')}
              aria-label="Go to home"
              size="small"
              sx={{ p: 0.5 }}
              disableRipple
            >
              <MiniLogo />
            </IconButton>
            {!isSuperAdmin && (
              <Typography
                sx={{
                  display: { xs: 'none', sm: 'block' },
                  maxWidth: 220,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 17,
                  fontWeight: 700,
                  color: '#0f172a',
                }}
              >
                {currentUser?.organization?.name || 'SignageTec'}
              </Typography>
            )}
          </Stack>

          <Stack direction="row" alignItems="center" spacing={2}>
            {isSuperAdmin && <OrganizationSwitch />}
            <Tooltip title="Sign out">
              <IconButton
                aria-label="Sign out"
                onClick={() => logout()}
                size="small"
                sx={{ color: '#2563eb' }}
              >
                <PowerSettingsNewIcon />
              </IconButton>
            </Tooltip>
            <Avatar
              sx={{
                width: 36,
                height: 36,
                bgcolor: '#4f46e5',
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              {userInitial}
            </Avatar>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
